export default __webpack_public_path__ + "static/media/b1.31ff735e.jpg";